import Component from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Alternatives/Assignments/Domain/commands-core';

@Component
export default class AssignmentsCommands extends VueCqrs 
{
	invokeBulkAssignUsersCommandV1(workspaceId: number, projectId: number, alternativeIds: string[], userIds: number[])
	{
		const cmd = new c.BulkAssignUsersCommandV1(workspaceId, projectId, alternativeIds, userIds);
		this.$command(cmd);
	}

	invokeAssignUserCommandV1(workspaceId: number, projectId: number, alternativeId: string, userId: number)
	{
		const cmd = new c.AssignUserCommandV1(workspaceId, projectId, alternativeId, userId);
		this.$command(cmd, userId.toString());
	}

	invokeUnassignUserCommandV1(workspaceId: number, projectId: number, alternativeId: string, userId: number)
	{
		const cmd = new c.UnassignUserCommandV1(workspaceId, projectId, alternativeId, userId);
		this.$command(cmd, userId.toString());
	}
}
